import React from 'react';
import { IconButton, Badge, Tooltip } from '@mui/material';
import { Notifications as NotificationsIcon } from '@mui/icons-material';
import { useUnreadCount } from '../../hooks/useNotifications';

interface NotificationBellProps {
  onClick: () => void;
}

export const NotificationBell: React.FC<NotificationBellProps> = ({ onClick }) => {
  const { data, isLoading } = useUnreadCount();

  const unreadCount = data?.data?.count || 0;

  return (
    <Tooltip title={unreadCount > 0 ? `${unreadCount} unread notifications` : 'Notifications'}>
      <IconButton
        color="inherit"
        onClick={onClick}
        sx={{
          position: 'relative',
        }}
      >
        <Badge
          badgeContent={unreadCount}
          color="error"
          max={99}
          invisible={isLoading || unreadCount === 0}
          sx={{
            '& .MuiBadge-badge': {
              fontSize: '0.7rem',
              height: 18,
              minWidth: 18,
            },
          }}
        >
          <NotificationsIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default NotificationBell;
